// extracted by mini-css-extract-plugin
module.exports = {"row":"SettingsData_row__3NmXt","label":"SettingsData_label__30hR2","value":"SettingsData_value__2RxTn"};